module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/name/prefix.js
// module id = 1317
// module chunks = 0